import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import {
  SliceResponse,
  SortDirectionType,
  SortType,
} from '../../types/listing'
import { ApiError } from '../../types/exception/errorStatus'
import { ProfileMetadata } from '../../types/user/userProfile'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export const useProfiles = () => {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const { authInfo } = useAuth()
  const { fetcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
  }

  const profiles = async (
    page = 0,
    size = 100,
    sort = SortType.DATE,
    direction = SortDirectionType.ASC,
    search = ''
  ): Promise<SliceResponse<ProfileMetadata> | null> => {
    setLoading(true)
    setError(null)

    try {
      const params = new URLSearchParams({
        page: String(page),
        size: String(size),
        sort,
        direction,
        search
      })

      return await fetcher<SliceResponse<ProfileMetadata>>(
        `${CONFIG.BOUNCE_API}/api/v1/profiles?${params}`
      )
    } catch (error) {
      console.error(error)

      if (error instanceof ApiError) {
        setError(getErrorMessage(error.data))
      } else {
        setError(t('unknown'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  return {
    profiles,
    loading,
    error,
    resetState,
  }
}
